// extracted by mini-css-extract-plugin
module.exports = {"container":"PPPagination_container__3rGqe","btnprevnext":"PPPagination_btnprevnext__1vtAQ","btnpages":"PPPagination_btnpages__1OEnN"};